import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=39a0ab00&scoped=true"
import script from "./Discuss.vue?vue&type=script&lang=js"
export * from "./Discuss.vue?vue&type=script&lang=js"
import style0 from "./Discuss.vue?vue&type=style&index=0&id=39a0ab00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0ab00",
  null
  
)

export default component.exports